export function urlToBlob(url: string): Promise<Blob> {
  return fetch(url).then((response) => response.blob());
}

export function blobToDataUrl(blob: Blob): Promise<string> {
  return new Promise((res, rej) => {
    const fileReader = new FileReader();
    fileReader.onload = (event) => {
      if (!event.target) {
        rej("blobToBase64: event.target is null!");
        return;
      }
      res(<string>event.target?.result);
    };
    fileReader.onerror = fileReader.onabort = () => {
      rej(fileReader.error);
    };

    fileReader.readAsDataURL(blob);
  });
}

export function urlToDataUrl(url: string): Promise<string> {
  return urlToBlob(url).then((blob) => blobToDataUrl(blob));
}

export function blobFromString(value: string): Blob {
  return new Blob([value], { type: "plain/text" });
}

export async function blobToArrayBuffer(blob: Blob): Promise<ArrayBuffer> {
  return await new Response(blob).arrayBuffer();
}

export async function blobToArrayBufferAsync(
  promiseBlob: Promise<Blob>
): Promise<ArrayBuffer> {
  return await new Response(await promiseBlob).arrayBuffer();
}

export async function blobToUInt8Array(
  blob: Blob,
  length?: number
): Promise<Uint8Array> {
  const arrayBuffer = await blobToArrayBuffer(blob);
  const uint8Array = new Uint8Array(arrayBuffer);
  return uint8Array;
}

export function blobFromArrayBufferAsync(
  arrayBuffer: Uint8Array | ArrayBuffer,
  type?: string
): Promise<Blob> {
  return Promise.resolve(
    new Blob([new Uint8Array(arrayBuffer)], {
      type: type
    })
  );
}

export async function blobToBase64(blob: Blob): Promise<string> {
  const dataUrl = await blobToDataUrl(blob);
  return dataUrl.substr(dataUrl.indexOf(",") + 1);
}

export async function dataUrlToBlob(dataUrl: string): Promise<Blob> {
  return (await fetch(dataUrl)).blob();
}

export async function downloadText(
  text: string,
  fileName: string,
  contentType: string
): Promise<void> {
  await downloadBlob(new Blob([text], { type: contentType }), fileName);
}

export async function downloadBlob(
  blob: Blob,
  fileName: string
): Promise<void> {
  const a: HTMLAnchorElement = document.createElement("a");
  let name = fileName || "download";

  a.setAttribute("download", name);
  a.rel = "noopener"; // tabnabbing

  a.href = URL.createObjectURL(blob);

  setTimeout(function () {
    URL.revokeObjectURL(a.href);
  }, 4e4); // 40s
  setTimeout(function () {
    a.click();
  }, 0);
}
